module.exports = "/static/fonts/fontawesome-webfont.fee66e7.woff";


//////////////////
// WEBPACK FOOTER
// ./font-awesome/fonts/fontawesome-webfont.woff
// module id = 1128
// module chunks = 2